function stringifyArray(arr) {
  if (!arr) return '';
  return arr.join(', ');
}
export default stringifyArray;
